<template>
  <asd20-modal
    :open="open"
    title="Send an Email"
    icon="email"
    dismissable
    windowed
    class="asd20-compose-email-modal"
    @dismiss="$emit('dismiss')"
  >
    <Asd20Viewport scrollable>
      <asd20-text-input
        id="senderName"
        label="Your Full Name"
        required
        @validated="validationErrors.senderName = $event"
        v-model="emailMessage.senderName"
      />
      <asd20-text-input
        id="senderEmail"
        type="email"
        :validator="validateEmailAddress"
        label="Your Email Address"
        required
        @validated="validationErrors.senderEmail = $event"
        v-model="emailMessage.senderEmail"
      />
      <asd20-text-area-input
        id="messageBody"
        label="Message"
        required
        @validated="validationErrors.messageBody = $event"
        v-model="emailMessage.messageBody"
      />
      <vue-recaptcha
        sitekey="6LfidKoUAAAAAFqr3QEbia3jIkecsZyxBYlMvWrX"
        :loadRecaptchaScript="true"
        size="invisible"
        @verify="captchaVerified"
      >
        <asd20-button v-show="isValid && !sending" label="Send" horizontal />
      </vue-recaptcha>
      <asd20-spinner size="sm" v-if="sending" />
    </Asd20Viewport>
  </asd20-modal>
</template>

<script>
import Asd20Modal from '../../molecules/Asd20Modal'
import Asd20TextInput from '../../molecules/Asd20TextInput'
import Asd20TextAreaInput from '../../molecules/Asd20TextAreaInput'
import Asd20Viewport from '../../atoms/Asd20Viewport'
import Asd20Spinner from '../../atoms/Asd20Spinner'
import VueRecaptcha from 'vue-recaptcha'
import Asd20Button from '../../atoms/Asd20Button'

export default {
  name: 'Asd20ComposeEmailModal',
  components: {
    Asd20Modal,
    Asd20TextInput,
    Asd20TextAreaInput,
    Asd20Viewport,
    Asd20Spinner,
    VueRecaptcha,
    Asd20Button,
  },
  props: {
    recipientId: { type: String, default: '', required: true },
    open: { type: Boolean, default: false },
  },
  data: () => ({
    validationErrors: {
      senderName: [],
      senderEmail: [],
      messageBody: [],
    },
    composing: false,
    sending: false,
    emailMessage: {
      senderName: '',
      senderEmail: '',
      messageBody: '',
    },
  }),
  computed: {
    isValid() {
      return (
        this.validationErrors.senderName.length === 0 &&
        this.validationErrors.senderEmail.length === 0 &&
        this.validationErrors.messageBody.length === 0
      )
    },
  },
  methods: {
    validateEmailAddress({ value, validationErrors }) {
      const pattern = /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/
      const regex = RegExp(pattern)
      if (!regex.test(value))
        validationErrors.push('A valid email address is required')
      return validationErrors
    },
    composeEmail() {
      if (!this.recipientId) return
      this.emailMessage = {
        senderEmail: '',
        senderName: '',
        messageBody: '',
      }
    },
    onInputValidated(errors) {
      this.validInputs += errors.length === 0 ? -1 : 1
    },
    captchaVerified(response) {
      if (response) this.sendEmail()
    },
    async sendEmail() {
      if (!this.isValid || !this.$sendEmail) return
      this.sending = true
      await this.$sendEmail(
        Object.assign({}, this.emailMessage, { recipientId: this.recipientId })
      )
      this.sending = false
      this.$emit('dismiss')
    },
  },
}
</script>

<style lang="scss" scoped>
@import '../../../design/_mixins.scss';
@import '../../../design/_variables.scss';

.asd20-compose-email-modal {
  &::v-deep .asd20-modal__content .asd20-viewport {
    padding: space(1);
  }
}

@media (min-width: 1024px) {
  .asd20-compose-email-modal {
    &::v-deep .asd20-modal__content .asd20-viewport {
      padding: space(1);
    }
    &::v-deep .asd20-modal {
      margin-top: auto;
      margin-bottom: auto;
      max-width: 30vw;
    }
  }
}
</style>
